import gql from 'graphql-tag';

export default gql`
  fragment FlightLocationFragment on FlightLocation {
    id
    name
    airport {
      locationId
      code
      title
      displayName
      city
      country
      state
      operatedBy
      geoPoint {
        latitude
        longitude
      }
    }
    destinations {
      id
      name
      heroImage
      airport {
        locationId
        code
        title
        displayName
        city
        country
        state
        operatedBy
        geoPoint {
          latitude
          longitude
        }
      }
    }
  }
`;
